import { PROVINCES } from 'store/enums';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: true,
  loaderText: null,
  streetType: null,
  maritalStatus: null,
  profession: null,
  sex: null,
  signType: null,
  provinces: PROVINCES,
  theme: 'default',
  legal: {},
  errorPage: {
    notFound: '',
    api: ''
  },
  townsCache: {},
  validatingDocuments: false,
  continueWithSave: false,
  validateFields: false,
  support: {},
  showFilesSigId: null,
  showFilesTypeDocumentText: null,
  showFilesDocuments: null,
  checkinoutMasterData: {
    storageParks: null,
    fuelTank: null,
    cleaning: null,
    wheels: null,
    brandTires: null,
    transportProviders: null,
    provinces: null,
    municipalities: null
  },
  selectedFlow: null,
  permissionFlow: null,
  informationTires: {
    front: {
      speedTiresOptions: [],
      loadTiresOptions: [],
      diameterTiresOptions: [],
      heightTiresOptions: [],
      widthTiresOptions: []
    },
    rear: {
      speedTiresOptions: [],
      loadTiresOptions: [],
      diameterTiresOptions: [],
      heightTiresOptions: [],
      widthTiresOptions: []
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
